import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FixedDatesSelectorComponent } from '../fixed-dates-selector/fixed-dates-selector.component';
import { RangeSelectorComponent } from '../range-selector/range-selector.component';

type FlowsType = 'fixed' | 'voting';

@Component({
  selector: 'at-dates-flow-selector',
  standalone: true,
  imports: [FixedDatesSelectorComponent, RangeSelectorComponent],
  templateUrl: './dates-flow-selector.component.html',
  styleUrl: './dates-flow-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatesFlowSelectorComponent {
  protected selectedFlow = signal<FlowsType>('fixed');
}
